module.exports = __webpack_public_path__ + "static/media/SJE089_03.fd87b676.jpg";